export default {
  data() {
    return {
      dataTableFilters: {
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        nextPage: null,
        prevPage: null,
        rowsPerPage: 10,
      },
      apiData: '',
      apiCallback: '',
    };
  },
  methods: {
    inititlizeDataTable({ apiCallback, apiData, sortBy }) {
      this.apiData = apiData;
      this.apiCallback = apiCallback;
      this.dataTableFilters.sortBy = sortBy;
    },
    nextPage() {
      const newPage = this.dataTableFilters.currentPage + 1;
      this.handlePagination(newPage);
    },
    previousPage() {
      const newPage = this.dataTableFilters.currentPage - 1;
      this.handlePagination(newPage);
    },
    handlePagination(newPage) {
      const apiCallback = this[this.apiCallback];

      if (this.dataTableFilters.currentPage < newPage) {
        this.dataTableFilters.nextPage = true;
      } else if (this.dataTableFilters.currentPage > newPage) {
        this.dataTableFilters.prevPage = true;
      }

      this.dataTableFilters.currentPage = newPage;
      apiCallback();
    },
    handleSort(payload) {
      const apiCallback = this[this.apiCallback];

      if (!payload.length) {
        this.dataTableFilters.sortBy = null;
        apiCallback();
        return;
      }

      const soryBy = payload[0];

      this.dataTableFilters.sortBy = soryBy;
      apiCallback();
    },
    handleSortDesc(payload) {
      if (!payload.length) {
        this.dataTableFilters.sortDesc = null;
        return;
      }

      const sortDesc = payload[0];
      const apiCallback = this[this.apiCallback];

      this.dataTableFilters.sortDesc = sortDesc;
      if (sortDesc) {
        apiCallback();
      }
    },
    getPaginationQuery(originalQuery) {
      let query = originalQuery;
      const data = this[this.apiData];

      if (this.dataTableFilters.sortBy && this.dataTableFilters.sortDesc) {
        query = query.orderBy(this.dataTableFilters.sortBy, 'desc');
      }

      if (this.dataTableFilters.sortBy && !this.dataTableFilters.sortDesc) {
        query = query.orderBy(this.dataTableFilters.sortBy);
      }

      if (this.dataTableFilters.nextPage) {
        const lastQuery = data[data.length - 1];
        query = query.startAt(lastQuery);
      }

      if (this.dataTableFilters.prevPage) {
        const firstQuery = data[0];
        query = query.endAt(firstQuery).limitToLast(this.dataTableFilters.rowsPerPage);
      } else {
        query = query.limit(this.dataTableFilters.rowsPerPage);
      }

      this.dataTableFilters.nextPage = null;
      this.dataTableFilters.prevPage = null;

      return query;
    },
  },
};
